<template>
<v-layout style="padding-top:49px;" row fill-height>
  <div class="loading" v-if="loading&&!isInstalling">
    <v-layout align-center justify-center row fill-height>
      <v-progress-circular :size="25" :width="3" color="grey" indeterminate >
      </v-progress-circular>
    </v-layout>
  </div>
  <v-snackbar v-model="isShowAlert" :timeout="timeout" top v-if="isSaved" color="success">
    <h3>Change Save Success</h3>
  </v-snackbar>
  <v-snackbar v-model="isShowAlert" :timeout="timeout" top v-if="!isSaved" color="error">
    <h3>Change Save Failed</h3>
  </v-snackbar>
  <app-header :hideRefresh="true" :hideTitle="true" :hideBackPage="true">
  </app-header>
  <v-container>
    <v-layout justify-center>
      <v-card class="event_card" outlined>
        <v-card-title>
          <v-img :src="appInfo.src" max-width="10vw"/>
          {{appInfo.name}}
          <v-spacer v-if="isWebApp"></v-spacer>
          {{appInfo.url}}
          <v-spacer></v-spacer>
          <v-btn  elevation="4" @click="goToStatusPage()" icon >
            <v-icon>undo</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout style="margin-left:10vw" align-center v-for="(value,key) in appFinalState" :key="key">
            <v-checkbox v-model="appFinalState[key]"  />            
            <h3> {{key+(key=='autostart'?' at ':'')}}</h3>
            <v-radio-group
              class="ml-4"
              v-if="key=='autostart'"
              v-model="selectedScreen"
              row
            >
              <v-radio v-for="i in 5"
                :label="`${i-1}`"
                :value="i-1"
                :key="i-1"
              ></v-radio>
            </v-radio-group>
          </v-layout>
        </v-card-text>
        <v-layout align-end justify-end>
          <v-card-actions v-on:click="goToStatusPage()">
            <v-btn elevation="0" width="5vw" rounded color="error">Cancel</v-btn>
          </v-card-actions>
          <v-card-actions >
            <v-btn elevation="0" width="5vw" rounded color="success" v-on:click="saveState()" :disabled="!mmsReady">Save</v-btn>
          </v-card-actions>
        </v-layout>
      </v-card>
    </v-layout>
  </v-container>
</v-layout>
</template>

<script>
import {
  set as setCookie,
  get as getCookie,
  remove as removeCookie
} from "es-cookie";
import webmms from "webmms-client";
import conf from "@/config/config";

export default {
  name:'pmAction',
  data(){
      return{
        selectedScreen:1,
        webBrowser:String,
        isWebApp:false,
        isSnap:false,
        isInstalling:false,
        isChange:false,
        isShowAlert:false,
        isSaved:false,
        installState:String,
        moteNow:'',
        moteDDN:'',
        appInfo:{},
        appInitialState:{},
        appFinalState:{},
        params: null,
        error: true,
        errorLoading: false,
        errorMsg: "",
        mmsReady: false,
        mms: null,
        eiInfo: {
          eiName: "",
          eiTag: "",
          ddn: ""
        },
        webmmsOptions: {
          EiToken: "",
          SToken: "",
          UToken: ""
        },
        infoSnack: false,
        infoSnakText: 'Sent successful',
        loading: false,
        isLoading: false,
        urt :{
          ddn: '',
          topic: '',
          func: '',
          payload: ''
        },
        eventList: [],
        timeout: 1000,
      }
  },
  watch:{
    selectedScreen(val){
      console.log(val);
    }
  },
  computed:{},
  created(){
        this.params = this.$route.query;
        this.setApp()
        this.startMMS();
  },
  async beforeMount() {
    await this.subscribeMMS();
  },
  async mounted(){
  },
  beforeDestroy() {
    this.removeEvent();
  },
  methods:{
    setApp(){
      if(this.params.udid!==null &&this.params.udid!==undefined){
          this.moteNow=this.params.udid
          this.moteDDN='>h3/'+this.moteNow+'/main-app'
        }
        if(typeof this.params.snap === 'object'){
          let {name,src}=this.params.snap
          this.appInfo={name,src}
          let {installed,autostart}=this.params.snap
          this.appInitialState={installed,autostart}
          this.appFinalState={installed,autostart}
          this.isSnap=true
        }
        else if(typeof this.params.webApp === 'object'){
          let {name,src,url}=this.params.webApp
          this.appInfo={name,src,url}
          let {autostart}=this.params.webApp
          this.appInitialState={autostart}
          this.appFinalState={autostart}
          this.webBrowser=this.params.browser
          this.isWebApp=true
        }
    },
    getLastItemInArray(array){
      return array[array.length-1]
    },
    async saveState(){
      if(this.isSnap){
        await this.saveInstalledState()
        await this.saveAutoStartState()
      }
      else if(this.isWebApp){
        await this.saveAutoStartState()
      }
      this.isShowAlert = true
      setTimeout(() => {
        if(this.isSaved)
          this.goToStatusPage()
      }, this.timeout);
    },
    async saveAutoStartState(){
      let temp = this.appFinalState.autostart

        if(temp){
          await this.createAutoStart()
         }
         else{
           await this.deleteAutoStart()
         }
         let data=this.getLastItemInArray(this.eventList).data[0]
         if(data.IN.State.ErrMsg==='OK'){
          this.isSaved = true
         /*await this.getAutoStartSnapList()
         data=this.getLastItemInArray(this.eventList).data[0]
         if(data.IN.State.ErrMsg==='OK'){
           let snapAutoStartList=data.Reply.ErrMsg.start
           if(snapAutoStartList.find(item=>item===this.appInfo.name+'.desktop')){
              this.appInitialState.autostart=true
            }
            else{
              this.appInitialState.autostart=false
            }
          }*/
        }
        else{
         this.isSaved = false
         this.appFinalState.autostart=this.appInitialState.autostart
        }
    },
    async createAutoStart(){
      this.deleteAutoStart();
      this.urt={
        ddn:this.moteDDN,
        topic:'mote://schedule',
        func:'',
        payload:{
          "operate": "create",
          "type": "boot",
          "job": this.appInfo.name,
          "workspace":this.selectedScreen,
          "terminal":0
        }
      }
      /*{"operate":"create","type":"boot","job":"smartscreen","command":"smartscreen","workspace":0,"terminal":0} */
      if(this.isSnap){
        this.urt.payload.command= this.appInfo.name
      }
      else if(this.isWebApp){
        this.urt.payload.command=this.webBrowser+"\t--new-window\t"+this.appInfo.url
      }
      await this.webmmsSubmit()
      this.urt.payload={
        "operate": "start",
        "type": "boot",
        "job": this.appInfo.name,
      }
      await this.webmmsSubmit()
    },
    async deleteAutoStart(){
      this.urt={
        ddn:this.moteDDN,
        topic:'mote://schedule',
        func:'',
        payload:{
          "operate": "delete",
          "type": "boot",
          "job": this.appInfo.name,
        }
      }
      await this.webmmsSubmit()
    },
    async saveInstalledState(){
      let temp = this.appFinalState.installed
      if(temp !== this.appInitialState.installed){
        if(temp){
          await this.installSnap()
          this.installState='installing'
         }
         else{
           await this.removeSnap()
           this.installState='removing'
         }
         let data=this.getLastItemInArray(this.eventList).data[0]
         if(data.IN.State.ErrMsg==='OK'){
          this.isSaved = true
          /*this.isInstalling=true
          const checkInstallState=setInterval(async()=>{
            await this.getInstalledSnapList()
            data=this.getLastItemInArray(this.eventList).data[0]
            if(data.IN.State.ErrMsg==='OK'){
              let snapInstalledList=data.Reply.ErrMsg
              if(this.installState==='installing'){
                console.log('install')
                if(snapInstalledList.find(item=>item.Name===this.appInfo.name)){
                  this.appInitialState.installed=true
                  this.isInstalling=false
                  clearInterval(checkInstallState)
                }
              }
              else if(this.installState==='removing'){
                console.log('remove')
                if(snapInstalledList.find(item=>item.Name===this.appInfo.name)===undefined){
                  this.appInitialState.installed=false
                  this.isInstalling=false
                  clearInterval(checkInstallState)
                }
              }
            }
          },1000)*/
        }
        else{
         this.isSaved = false
         this.appFinalState.installed=this.appInitialState.installed
        }
       }
       else{
         this.isSaved=true
        }
    },
    async installSnap(){
      this.urt={
        ddn:this.moteDDN,
        topic:'mote://apt',
        func:'',
        payload:{
          "operate":"install",
          "type":"snap",
          "packageName":this.appInfo.name
        }
      }
      await this.webmmsSubmit()
    },
    async removeSnap(){
      this.urt={
        ddn:this.moteDDN,
        topic:'mote://apt',
        func:'',
        payload:{
          "operate":"remove",
          "type":"snap",
          "packageName":this.appInfo.name
        }
      }
      await this.webmmsSubmit()
    },
    /*async getAutoStartSnapList(){
        this.urt={
          ddn:this.moteDDN,
          topic:'mote://schedule',
          func:'',
          payload:{
            "operate": "list",
            "type": "boot"
          }
        }
        await this.webmmsSubmit()
        //console.log('Get AutoStart Snap List')
    },
    async getInstalledSnapList(){
      this.urt={
        ddn:this.moteDDN,
        topic:'mote://apt',
        func:'',
        payload:{
          "operate": "list",
          "type": "snap"
        }
      }
      await this.webmmsSubmit()
      //console.log('Get Installed Snap List')
    },*/
    goToBackPage(){
      this.$router.go(-1);
    },
    goToStatusPage(){
      this.$router.replace({path:'/pm',query:{udid:this.moteNow}})
    },
    checkWebMMSState() {
      if (!this.mmsReady) {
        this.errorMsg = "WebMMS is not connected or registered.";
        this.errorLoading = true;
        return false;
      } else return true;
    },
    setLog(data, type){
        let _data =typeof data == 'object' ? Object.assign({},data) : {data : data};
        if(_data.payload){
          _data.payload = this.isJson(_data.payload) ? JSON.parse(_data.payload) : _data.payload;
        }
        let log = {
            time : this.getTime(),
            data : _data,
            type: type
        };
        
        this.eventList.push(log);
    },
    async webmmsSubmit(){
        //this.$validator.validateAll();
        const { ddn, topic, func, payload } = this.urt;
        if(func && func != ''){
            this.loading = true;
            let res;
            try {
               res = await this.mms.callMMS({
                  DDN : ddn,
                  topic : topic,
                  func: func,
                  payload: this.isJson(payload) ? JSON.parse(payload) : payload
              });
            } catch (error) {
              this.setLog({'websocket': error}, 'State');
            }
            this.loading = false;
            if(res){
                let result;
                if(typeof res == 'object')
                    result = res;
                else
                    result = res[0];
                console.log(result);
                if(!result)
                  return;
                this.setLog(result, 'Out');
            }
        }else{
           this.loading = true;
           let res;
           try {
               res = await this.mms.sendMMS({
                  DDN : ddn,
                  topic : topic,
                  payload: this.isJson(payload) ? JSON.parse(payload) : payload
              });
           } catch (error) {
             this.setLog({'websocket': error}, 'State');
           }
            this.loading = false;

            if(res){
                let result;
                if(typeof res == 'object')
                    result = res;
                else
                    result = res[0];
                console.log(result);
                if(!result)
                  return;
                this.setLog(result, 'Out');
            }
        }

      },
    startMMS() {
      this.mms = webmms({
        wsurl: conf.wsurl,
        EiToken: getCookie("jj-EiToken") || "",
        SToken: getCookie("jj-SToken") || ""
      });
    },
    async subscribeMMS() {
      this.removeEvent = this.mms.on("registered", async reply => {
        //console.log('reply=%s', JSON.stringify(reply))
        this.errorMsg=reply.ErrMsg
        if (reply.ErrMsg == "OK") {
          this.eiInfo.ddn = reply.result.DDN;
          this.webmmsOptions.EiToken = reply.result.EiToken;
          this.webmmsOptions.SToken = reply.result.SToken;
          this.webmmsOptions.UToken = reply.result.UToken;
          if (this.eiInfo.eiName == "") {
            this.eiInfo.eiName = reply.result.EiName
              ? reply.result.EiName
              : "jb" + this.makeId(5);
          }
          if (this.eiInfo.eiTag == "") {
            this.eiInfo.eiTag = reply.result.EiTag ? reply.result.EiTag : "";
          }
          this.mmsReady = true;
          this.error = false;
        } else {
          this.mmsReady = false;
          this.error = false;
        }

        setCookie("jj-EiToken", this.webmmsOptions.EiToken);
        setCookie("jj-SToken", this.webmmsOptions.SToken);

        console.log("regtoCenter: %s", reply.ErrMsg);
        this.setLog({'regtoCenter':reply}, 'State');
        let deviceInfo = {
          DDN: this.eiInfo.ddn,
          EiOwner: "",
          EiName: this.eiInfo.eiName,
          EiType: ".page",
          EiTag: this.eiInfo.eiTag,
          EiLoc: ""
        };
        let result = await this.mms.setDeviceInfo(deviceInfo);

        console.log("SetDevice reply=%s", JSON.stringify(result));
      });

      this.mms.on('message', (method, from, data, body) => {
             this.mmsReady = true;
             this.error = false;
             console.log('rcve: from=%s, data=%s', from, JSON.stringify(data));
            if(typeof data == 'object' && !data.from)
              data.from = from;
            //body.sender = data;
            if(data)
            {

              //this.eventList.push(data.data);
              this.setLog({From : from, Data: data}, 'In');

            }
        });

        this.mms.on('state', msg => {
            console.log('WS error: %s', msg);
            this.setLog({'WS error':msg}, 'State');
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.mms.on('disconnect', msg => {
            this.setLog({'disconnect':msg}, 'State');
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.mms.on('error', err => {
            this.setLog({'error':err}, 'State');
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.mms.on('connect_error', err => {
            this.setLog({'connect_error':err}, 'State');
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.mms.on('connect_timeout', err => {
             this.setLog({'connect_timeout':err}, 'State');
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });
      }

    }
}
</script>

<style scoped>
.event_card{
   box-shadow: none;
   width: 95vw;
   background-color: rgb(250, 248, 248);
}
.header_layout{
  margin-top: -5px;
}
.event_header{
  /* background-color:#e9fafb; */
  height: 45px;
  box-shadow: none;
  padding-top: 10px;
  border:none;
  position: fixed;
  top: 0;
  z-index: 2;
}
.card_form{
    margin-top: 5px;
    box-shadow: none;
    border:none;
    background-color: #fff;
}
.event_body{
   /* background-color:#e9fafb; */
}
.event_status_success{
   background-color:#08b325;
   border-color: #08b325;
}
.event_status_failed{
   background-color: #d22727;
   border-color: #b72626;
}
li {
    display: flex;
    align-items: center;
}
label {
display: inline-block;

}
.loading{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left:0;
  z-index: 50;
  background-color: rgba(255, 255, 255, 0.4196078431372549);
}
.urt_form{
    margin-bottom: 0;
    background-color: #fff;
}
</style>